import { render, staticRenderFns } from "./MunicipalityEditor.vue?vue&type=template&id=0d49c63e"
import script from "./MunicipalityEditor.vue?vue&type=script&lang=js"
export * from "./MunicipalityEditor.vue?vue&type=script&lang=js"
import style0 from "./MunicipalityEditor.vue?vue&type=style&index=0&id=0d49c63e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports